import { Controller } from "@hotwired/stimulus"

// Shows the box age-range message matching the selected reading level.
// Each radio carries its pre-computed message in data-reading-level-message-text.
export default class extends Controller {
  static targets = ["message", "text"]

  connect() {
    const checked = this.element.querySelector('input[name="grade_level"]:checked')
    if (checked) {
      this.display(checked)
    }
  }

  show(event) {
    this.display(event.target)
  }

  display(input) {
    const text = input.dataset.readingLevelMessageText
    if (!text) return

    this.textTarget.textContent = text
    // Re-trigger the fade-in animation on every selection change
    this.messageTarget.classList.remove("visible")
    void this.messageTarget.offsetWidth
    this.messageTarget.classList.add("visible")
  }
}
